var map = {
	"./advisors.js": "3d7f",
	"./features.js": "929f",
	"./games.js": "918f",
	"./index.js": "2a74",
	"./instructions.js": "fad8",
	"./nfts.js": "7ec5",
	"./partners.js": "c4ca",
	"./team.js": "0520"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d307";